import React from 'react';
import {SearchResultItem} from './search-result-item';
import {useTranslation} from 'react-i18next';
import {InfiniteScroll} from 'antd-mobile';

const InfiniteScrollContent = ({hasMore}: {hasMore?: boolean}) => {
  const {t} = useTranslation();
  return (
    <>
      {hasMore ? (
        <>
          <span>{t('label.loading')}</span>
        </>
      ) : (
        <span>{t('label.noMore')}</span>
      )}
    </>
  );
};

export function SearchResult({
  list,
  totalSize,
  loadMore,
  hasMore,
}: {
  list: any[];
  totalSize: number;
  loadMore: (isRetry?: boolean) => Promise<void>;
  hasMore: boolean;
}) {
  return (
    <div className="bg-gradient-to-b from-white to-white/0 mt-3">
      <div className="flex items-center justify-between p-3">
        <div className="text-t1 text-sm font-bold">search Result</div>
        <div className="text-xs font-medium text-t2">
          About{' '}
          <span className="text-[#9800F5]">
            {totalSize > 99 ? '99+' : totalSize}
          </span>{' '}
          results
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2 px-3">
        {list.map((item, index) => {
          return <SearchResultItem {...item} key={index} />;
        })}
      </div>
      <InfiniteScroll
        threshold={100}
        loadMore={async () => {
          return loadMore();
        }}
        hasMore={hasMore}>
        <InfiniteScrollContent hasMore={hasMore} />
      </InfiniteScroll>
    </div>
  );
}
